<script lang="ts">
	import { push } from 'svelte-spa-router';
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { Toggle, Alert, Button } from '@Shelly/shelly-design-system';
	//Helpers
	import { user_data } from 'src/stores/account/user';
	import { capFirstChar } from 'src/helpers/utilities';
	import { accessibleVirtualDevices } from 'src/helpers/virtual_helpers/virtual_components_helpers';
	export let extractAsDevice: boolean;
	export let showModal: boolean;
	export let disabled = false;

	const extractedAsDevice = !extractAsDevice;
</script>

{#if !$user_data.premium}
	<Alert
		class="mb-s"
		type="info"
		customIcon="fas fa-gem icon-premium-color"
		heading={$format('heading_alert_get_premium_virtual_devices', {
			default: 'To extract more than one virtual group as device, you need to be a premium user.',
		})}
	>
		<Button
			slot="bottom"
			variant="premium"
			size="m"
			width="auto"
			on:click={() => {
				showModal = false;
				push('/settings/premium');
			}}
		>
			{capFirstChar(
				$format('button_get_premium', {
					default: 'Get Premium',
				}),
			)}
		</Button>
	</Alert>
{/if}
<Toggle
	size="m"
	class="mb-s"
	bind:checked={extractAsDevice}
	disabled={disabled || (extractedAsDevice && !accessibleVirtualDevices())}
	id="toggle-dwrz4ha"
>
	{$format('settings_group_virtual_component_extract_as_device', {
		default: 'Extract virtual group as device',
	})}
</Toggle>
